// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React from 'react'
import { Grommet } from 'grommet'
import { useTranslation } from 'react-i18next'
import { PropTypes } from 'prop-types'
import { Copy } from 'grommet-icons'
import { hpe } from 'grommet-theme-hpe'
import { deepMerge } from 'grommet/utils'

import { Button, FormTextArea, Tooltip } from '../../../../components'

const theme = deepMerge(hpe, {
  formField: {
    border: {
      color: 'transparent'
    }
  }
})

const TextAreaInputWithCopyButton = ({
  testId,
  label = '',
  value = '',
  copyTextCallback = () => {}
}) => {
  const { t } = useTranslation(['authz'])
  const copyTextContent = () => {
    navigator.clipboard.writeText(value)
    copyTextCallback()
  }
  return (
    <Grommet theme={theme}>
      <FormTextArea
        action={
          <Button
            testId="copy-btn"
            default
            hoverIndicator="none"
            onClick={copyTextContent}
            aria-label="Copy to clipboard"
            margin={{ top: 'small' }}
          >
            {({ hover, focus }) => (
              <Tooltip
                dropProps={{ align: { left: 'right' } }}
                info={
                  <>
                    {hover && !focus ? t('copy') : null}
                    {hover && focus ? t('copied') : null}
                  </>
                }
                testId="copy-tooltip"
              >
                <Copy aria-hidden />
              </Tooltip>
            )}
          </Button>
        }
        disabled
        value={value}
        inputType="text"
        label={label}
        name="form-disabled-text-area-input-with-copy-btn"
        testId={`${testId}-text-field`}
      />
    </Grommet>
  )
}

TextAreaInputWithCopyButton.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  testId: PropTypes.string.isRequired,
  copyTextCallback: PropTypes.func
}

export default TextAreaInputWithCopyButton
